import React from "react";
import { QUIZ_ANSWER_STATES } from "../constants";

function ReviewButton({ state, link }) {
  switch (state) {
    case QUIZ_ANSWER_STATES.SKIPPED:
    case QUIZ_ANSWER_STATES.CORRECT:
      return (
        <a href={link} className="review-button btn btn-default btn-sm">
          Review
        </a>
      );
    case QUIZ_ANSWER_STATES.INCORRECT:
    case QUIZ_ANSWER_STATES.LOCKED:
    case QUIZ_ANSWER_STATES.DISABLED:
    case QUIZ_ANSWER_STATES.UNLOCKED:
    default:
      return null;
  }
}

export default ReviewButton;
